<template>
    <div>
        <v-snackbar
            v-for="(snackBar, index) in snackBars.filter(s => s.showing)"
            :key="snackBar.message + Math.random()"
            v-model="snackBar.showing"
            :timeout="snackBar.timeout"
            :color="snackBar.color"
            :style="`bottom: ${(index * 60) + 8}px`"
            right>
            {{snackBar.message}}
            <template v-slot:action="{ attrs }">
                <v-btn
                    icon
                    v-bind="attrs"
                    @click="snackBar.showing = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    name: "SnackbarAlert",
    components: {
        
    },
    computed: {
        ...mapState('common/snackBar', ["snackBars"]),
       
    },
   
    methods: {
        // createdData() {
        //     this.play("https://www.pacdv.com/sounds/interface_sound_effects/sound56.wav");
        // },
        // close() {
        //     Object.assign(this.$data, this.$options.data.apply(this));
        // },
        // play(params) {
        //     if(params) {
        //         var audio = new Audio(params);
        //         audio.play();
        //     }
        // }
    },
    // updated() {
    //     this.createdData();
    // }
}
</script>

<style lang="scss" scope>
.bg-success-snackbar {
    background-color: #4caf50 ;
}
.bg-error-snackbar {
    background-color: red ;
}
</style>